import { z } from 'zod';

import {
  accreditationStageChangedNotificationSchema,
  accreditationStageChangedNotificationType,
} from './AccreditationStageChangedNotification';
import { fixationPeriodNotificationSchema, fixationPeriodNotificationType } from './FixationPeriodNotification';
import { otherNotificationSchema, otherNotificationType } from './OtherNotification';
import {
  newsNotificationType,
  promotionNotificationType,
  publicationNotificationSchema,
} from './PublicationNotification';

export const notificationType = z.enum([
  fixationPeriodNotificationType.value,
  accreditationStageChangedNotificationType.value,
  promotionNotificationType.value,
  newsNotificationType.value,
  otherNotificationType.value,
]);

export type NotificationType = z.output<typeof notificationType>;

export const notificationsTypeTextsMap: Record<NotificationType, string> = {
  LEAD_EXP: 'Истечение срока фиксации',
  ACCREDITATION_STAGE_CHANGED: 'Аккредитация',
  PROMOTION: 'Акции',
  NEWS: 'Новости',
  OTHER: 'Другое',
};

export const notificationSchema = z.union([
  otherNotificationSchema,
  fixationPeriodNotificationSchema,
  accreditationStageChangedNotificationSchema,
  publicationNotificationSchema,
]);

export type NotificationEntityApi = z.input<typeof notificationSchema>;

export type NotificationEntity = z.infer<typeof notificationSchema>;
